'use client'
import { useSearchParams } from 'next/navigation'
import { useEffect, useState } from 'react'

import Shared from '@/shared'

import { StorageQueryKeys } from '@/enums/query'

import { QueryProvider } from '@/app/queryProvider'

export default function ClientContainer(props: { children: React.ReactNode }) {
  const searchParams = useSearchParams()
  const newGuestSeq = searchParams.get(StorageQueryKeys.GUEST_SEQ)
  const newCarNum = searchParams.get(StorageQueryKeys.CAR_NUM)
  const [isComponentMounted, setIsComponentMounted] = useState(false)

  const { guestSeq, setGuestSeq, setCarnum } = Shared.States.useStorageStore()

  useEffect(() => {
    if (!newGuestSeq && guestSeq == null) {
      const defaultGuestSeq = 0
      setGuestSeq(defaultGuestSeq)
    }
    if (newGuestSeq && Number(newGuestSeq) !== guestSeq) {
      setGuestSeq(Number(newGuestSeq))
    }
  }, [newGuestSeq])

  useEffect(() => {
    if (newCarNum) {
      setCarnum(newCarNum)
    }
  }, [newCarNum])

  useEffect(() => {
    setIsComponentMounted(true)
  }, [])

  return isComponentMounted ? <QueryProvider>{props.children}</QueryProvider> : <></>
}
